import { Progress } from "antd";
import './styles.css';

interface IFinepPercentageProps {
    filled: number,
    validated: number,
}

const FinepPercentage = (props: IFinepPercentageProps) => {
    return (
        <div className="finep-container">
            <h2 className="finep-title">FINEP</h2>
            <div className="finep-progress-wrapper">
                <div className="finep-text">
                    <span className="finep-filled-text">Preenchido: {props.filled} %</span>
                    <span className="finep-validated-text">Validado: {props.validated} %</span>
                </div>
                <div className="finep-progress-bar">
                    <Progress percent={props.filled} status="active" strokeColor="#0000A4" strokeWidth={10} style={{ width: "250px", }} />
                </div>
            </div>
        </div>
    )
}

export default FinepPercentage;